module.exports = __webpack_public_path__ + "static/13.2-1767197836b158b1adaf2ffa39682bbf.jpg";